import React, { ComponentType, useEffect, useState } from 'react';

import { Modal } from 'react-bootstrap';

import { useHistory } from 'react-router-dom';

import useGlobalState from '../GlobalStateContext';

import { OptionalRolesOrPermissions } from 'crm/helpers/Permissions';
import { getRootAndIdFromUrl } from 'crm/helpers/UrlHelper';

type Props = {
    url: string;
    title: string;
    AttachEl: ComponentType<any>;
    setUpdateTrigger?: Function;
} & OptionalRolesOrPermissions;

export default function AttachModalButton({
    url,
    title,
    AttachEl,
    roles = [],
    permissions = [],
    setUpdateTrigger,
}: Readonly<Props>) {
    const { loggedAdmin } = useGlobalState();
    const [showModal, setShowModal] = useState(false);
    const [wasAttached, setWasAttached] = useState(false);
    const { root, id } = getRootAndIdFromUrl(url);
    const urlParams = new URLSearchParams(window.location.search);
    const urlKey = `${title}_${id}`;
    const trigger = urlParams.get(urlKey);
    const history = useHistory();

    const handleShowModalClick = () => {
        setShowModal(true);
        urlParams.set(`${title}_${id}`, 'true');
        history.push({
            search: urlParams.toString(),
        });
    };

    useEffect(() => {
        if (!trigger) {
            setShowModal(false);
            if (wasAttached && setUpdateTrigger) {
                setUpdateTrigger(() => Math.random());
            }
            setWasAttached(false);
        } else {
            setShowModal(true);
        }
    }, [trigger]);

    return loggedAdmin.hasAccess(roles, permissions) ? (
        <>
            <button onClick={handleShowModalClick} className="btn btn-primary btn-sm mb-3 mr-3">
                {title}
            </button>
            <Modal scrollable show={showModal}>
                <AttachEl root={root} id={id} setWasAttached={setWasAttached} />
            </Modal>
        </>
    ) : null;
}
